"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _reactTextareaAutosize = _interopRequireDefault(require("react-textarea-autosize"));

var _Field = require("../Field/Field");

var _Field2 = require("../Field/Field.styles");

var _Tooltip = _interopRequireWildcard(require("../Tooltip/Tooltip"));

var _icons = require("../../assets/icons");

var _Help = _interopRequireDefault(require("../Field/Help/Help"));

var _elements = require("../../styles/elements");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Textarea = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var name = _ref.name,
      label = _ref.label,
      tooltipTitle = _ref.tooltipTitle,
      tooltipPosition = _ref.tooltipPosition,
      className = _ref.className,
      validateStatus = _ref.validateStatus,
      help = _ref.help,
      disabled = _ref.disabled,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      autoSize = _ref.autoSize,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, ["name", "label", "tooltipTitle", "tooltipPosition", "className", "validateStatus", "help", "disabled", "onFocus", "onBlur", "autoSize"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var handleFocus = (0, _react.useCallback)(function (e) {
    setFocused(true);
    onFocus(e);
  }, [onFocus]);
  var handleBlur = (0, _react.useCallback)(function (e) {
    setFocused(false);
    onBlur(e);
  }, [onBlur]);
  var fieldConfig = {
    id: name,
    name: name,
    onFocus: handleFocus,
    onBlur: handleBlur,
    className: 'grui',
    css: _elements.textarea.styles.preflight
  };
  return (0, _jsxRuntime.jsxs)("div", {
    css: _Field2.styles.fieldContainer,
    className: className,
    children: [label && (0, _jsxRuntime.jsxs)("div", {
      css: _Field2.styles.labelBox,
      children: [(0, _jsxRuntime.jsx)("label", {
        htmlFor: name,
        children: label
      }), tooltipTitle && (0, _jsxRuntime.jsx)(_Tooltip["default"], {
        position: tooltipPosition,
        title: tooltipTitle,
        children: (0, _jsxRuntime.jsx)(_icons.Question, {})
      })]
    }), (0, _jsxRuntime.jsx)(_Field.FormControl, {
      focused: focused,
      validateStatus: validateStatus,
      disabled: disabled,
      children: autoSize ? (0, _jsxRuntime.jsx)(_reactTextareaAutosize["default"], _objectSpread(_objectSpread(_objectSpread({}, fieldConfig), otherProps), {}, {
        maxRows: autoSize && autoSize.maxRows,
        minRows: autoSize && autoSize.minRows,
        ref: ref
      })) : (0, _jsxRuntime.jsx)("textarea", _objectSpread(_objectSpread(_objectSpread({}, fieldConfig), otherProps), {}, {
        ref: ref
      }))
    }), help && (0, _jsxRuntime.jsx)(_Help["default"], {
      help: help,
      validateStatus: validateStatus
    })]
  });
});

Textarea.propTypes = {
  name: _propTypes.string.isRequired,
  label: _propTypes.string,
  tooltipTitle: _propTypes.string,
  tooltipPosition: (0, _propTypes.oneOf)(_Tooltip.positions),
  className: _propTypes.string,

  /**
   * ValidateStatus is for showing validation result
   * help is for validation hint
   */
  validateStatus: (0, _propTypes.oneOf)(['success', 'error']),
  help: _propTypes.string,
  onFocus: _propTypes.func,
  onBlur: _propTypes.func,
  disabled: _propTypes.bool,

  /**
   * Height autosize feature, can be set to true | false or an object { minRows: 2, maxRows: 6 }
   */
  autoSize: (0, _propTypes.oneOfType)([_propTypes.bool, (0, _propTypes.shape)({
    minRows: _propTypes.number,
    maxRows: _propTypes.number
  })])
};
Textarea.defaultProps = {
  label: undefined,
  tooltipTitle: undefined,
  tooltipPosition: 'top',
  className: undefined,
  validateStatus: undefined,
  help: undefined,
  onFocus: function onFocus() {},
  onBlur: function onBlur() {},
  disabled: false,
  autoSize: false
};
Textarea.displayName = 'Textarea';
var _default = Textarea;
exports["default"] = _default;
//# sourceMappingURL=Textarea.js.map